import * as React from "react"
import colors from "theme/colors"

const SvgComponent = ({
  color = colors.black,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 24
  const h = 24
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="0.25"
        y="0.25"
        width="23.5"
        height="23.5"
        rx="2.75"
        fill={color}
      />
      <path
        d="M17.5 8L10.1667 16L6.5 12"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="0.25"
        y="0.25"
        width="23.5"
        height="23.5"
        rx="2.75"
        stroke={color}
        strokeWidth="0.5"
      />
    </svg>
  )
}

export default SvgComponent
